export default {
  BUY_OR_PAY: 1,
  RETURN_REMAIN: 2
};

export const PaymentTitle = {
  1: "خرید یا پرداخت هزینه",
  2: "عودت تنخواه"
};
